/**
 * replaceURLParameters
 *
 * Replaces :{string} placeholders with values given and returns the result
 * Eg. /test/:id => /test/1234
 *
 * @param endpoint - The location to send the request
 * @param params - An object containing the keys to replace and the values to replace them with
 */
export const replaceURLParameters = (
    endpoint: string,
    params?: Record<string, string>,
): string => {
    // If no params are provided then return the unchanged endpoint
    if (!params) return endpoint;

    // Uses Array.reduce to take the original endpoint and recursively replace each parameter placeholder with the
    // corresponding key in the params object
    return Object.entries(params).reduce(
        (updatedEndpoint, [key, value]) =>
            // return the updated endpoint with the key value replaced
            updatedEndpoint.replace(`:${key}`, value),
        endpoint,
    );
};
